'use strict';

/**
 * This is the main entry point of the navigation plugin namespace
 * The only thing exposed is a create function, users should
 * be able to interact with the core directly after that.
 *
 * src/main.js
 */

ISMDSPlugin.define('src/js/main',['./ice.ismds.plugin'], function (ISMDSPlugin) {
  return {
    create: function create(core, options) {
      return new ISMDSPlugin(core, options);
    }
  };
});

